module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2f"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/foreword#for"
    }
  }, [_c('em', [_vm._v("Foreword")])]), _vm._v(" \\ "), _c('span', {
    staticClass: "small"
  }, [_vm._v("CAROLYN KORSMEYER")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#int"
    }
  }, [_c('strong', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/part01#part1"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" 1. R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVISING THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONCEPT OF")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAUTY")]), _vm._v(":"), _c('br'), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AYING THE")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROUNDWORK")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ch1"
    }
  }, [_c('strong', [_vm._v("1."), _c('br'), _vm._v("Arthur Danto and the Problem of Beauty")])]), _vm._v(" \\ "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NOËL CARROLL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("2."), _c('br'), _vm._v("Savages, Wild Men, Monstrous Races: The Social Construction of Race in the Early Modern Era")])]), _vm._v(" \\ "), _c('span', {
    staticClass: "small"
  }, [_vm._v("GREGORY VELAZCO Y TRIANOSKY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3."), _c('br'), _vm._v("Beauty’s Relational Labor")])]), _vm._v(" \\ "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MONIQUE ROELOFS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4."), _c('br'), _vm._v("Queer Beauty: Winckelmann and Kant on the Vicissitudes of the Ideal")])]), _vm._v(" \\ "), _c('span', {
    staticClass: "small"
  }, [_vm._v("WHITNEY DAVIS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5."), _c('br'), _vm._v("Worldwide Women")])]), _vm._v(" \\ "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELEANOR HEARTNEY")])]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02#part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" 2. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TANDARDS OF")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAUTY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("6."), _c('br'), _vm._v("Jenny Saville Remakes the Female Nude: Feminist Reflections on the State of the Art")])]), _vm._v(" \\ "), _c('span', {
    staticClass: "small"
  }, [_vm._v("DIANA TIETJENS MEYERS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("7."), _c('br'), _vm._v("Indigenous Beauty")])]), _vm._v(" \\ "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOEBE M. FARRIS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("8."), _c('br'), _vm._v("Is Medical Aesthetics Really Medical?")])]), _vm._v(" \\ "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MARY DEVEREAUX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/ch09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("9."), _c('br'), _vm._v("The Bronze Age Revisited: The Aesthetics of Sun Tanning")])]), _vm._v(" \\ "), _c('span', {
    staticClass: "small"
  }, [_vm._v("JO ELLEN JACOBS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("10."), _c('br'), _vm._v("¿Tienes Culo? How to Look at Vida Guerra")])]), _vm._v(" \\ "), _c('span', {
    staticClass: "small"
  }, [_vm._v("KARINA L. CÉSPEDES-"), _c('br'), _vm._v("CORTES AND PAUL C. TAYLOR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("11."), _c('br'), _vm._v("Beauty between Disability and Gender: Frida Kahlo in Paper Dolls")])]), _vm._v(" \\ "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FEDWA MALTI-DOUGLAS")])]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03#part3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" 3. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODY IN")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERFORMANCE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("12."), _c('br'), _vm._v("Beauty, Youth, and the Balinese "), _c('em', [_vm._v("Legong")]), _vm._v(" Dance")])]), _vm._v(" \\ "), _c('span', {
    staticClass: "small"
  }, [_vm._v("STEPHEN DAVIES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("13."), _c('br'), _vm._v("Bollywood and the Feminine: Hinduism and Images of Womanhood")])]), _vm._v(" \\ "), _c('span', {
    staticClass: "small"
  }, [_vm._v("JANE DURAN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("14."), _c('br'), _vm._v("Seductive Shift: A Review of "), _c('em', [_vm._v("The Most Beautiful Woman in Gucha")])])]), _vm._v(" \\ "), _c('span', {
    staticClass: "small"
  }, [_vm._v("VALERIE SULLIVAN FUCHS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("15."), _c('br'), _vm._v("Feminist Art, Content, and Beauty")])]), _vm._v(" \\ "), _c('span', {
    staticClass: "small"
  }, [_vm._v("KEITH LEHRER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("16."), _c('br'), _vm._v("ORLAN Revisited: Disembodied Virtual Hybrid Beauty")])]), _vm._v(" \\ "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PEG ZEGLIN BRAND")])]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part04#part4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" 4. B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAUTY AND THE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TATE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("17."), _c('br'), _vm._v("Beauty Wars: The Struggle over Female Modesty in the Contemporary Middle East and North Africa")])]), _vm._v(" \\ "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLEN DOUGLAS AND FEDWA MALTI-DOUGLAS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("18."), _c('br'), _vm._v("Orientalism Inside/Out: The Art of Soody Sharifi")])]), _vm._v(" \\ "), _c('span', {
    staticClass: "small"
  }, [_vm._v("CYNTHIA FREELAND")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("19."), _c('br'), _vm._v("Beauty and the State: Female Bodies as State Apparatus and Recent Beauty Discourses in China")])]), _vm._v(" \\ "), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVA KIT WAH MAN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/ch20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("20."), _c('br'), _vm._v("Gendered Bodies in Contemporary Chinese Art")])]), _vm._v(" \\ "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MARY BITTNER WISEMAN")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contributors#con",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Contributors")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0